import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const HowSubmit = () => {
  return (
    <Container>

<p className="joab-common-para my-2 ">
      Here we provide an outline of the editorial process involved in publishing a scientific paper. The information below describes how manuscripts are handled once online submitted to a journal by editors.
      </p>
    <h2 className="display-6 fw-bold my-4">
    How to submit an Article
    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      Authors should use the  <b>Author Guidelines</b> to ensure that the length and format (particularly the layout of figures and tables and any Supplementary Information) conforms with the specific journal’s requirements, as well as submission and revision stage.
      </p>
      <p className="joab-common-para my-2 ">
      Manuscripts should be submitted via our online manuscript submission system. A cover letter is mandatory because this is an excellent opportunity to briefly discuss the importance of the submitted work and why it is appropriate for the journale.
      </p>
      <p className="joab-common-para my-2 ">
      The cover letter is not shared with the referees, and should be used to provide confidential information such as conflicts of interest and to declare any related work that is in press or submitted elsewhere.
      </p>
   
    

  </Container>
  );
};

export default HowSubmit;
